(function () {
  if (window.customerDetailsInitialized) return;
  window.customerDetailsInitialized = true;

  const SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbzHf2V0HBlo0T-sW8p0YfzBYf4_n5S1NjRJ7lg9duRX5DyBkpy_Re3R6oLmb6vEDZal0A/exec';

  const modal = document.getElementById('CustomerDetailsModal');
  if (!modal) return;

  const nameInput = modal.querySelector('[data-customer-name]');
  const phoneInput = modal.querySelector('[data-customer-phone]');
  const stateInput = modal.querySelector('[data-customer-state]');
  const phoneWarning = modal.querySelector('[data-phone-warning]');
  const error = modal.querySelector('[data-customer-error]');
  const continueButton = modal.querySelector('[data-customer-continue]');

  let activeForm = null;
  let activeButton = null;
  let submitting = false;

  // Tracks whether customer details have been submitted
  // for the current cart.
  let customerDetailsCompleted = false;
  let cartCheckComplete = false;

  async function checkCartStatus() {
    try {
      const response = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });

      if (!response.ok) {
        throw new Error('Could not check cart status.');
      }

      const cart = await response.json();

      // If the cart already contains products, skip the modal.
      customerDetailsCompleted = cart.item_count > 0;
    } catch (err) {
      console.error('Cart status check failed:', err);
    } finally {
      cartCheckComplete = true;
    }
  }

  // Check the cart before allowing Add to Cart interception.
  const cartReady = checkCartStatus();

  function showError(message) {
    error.textContent = message;
    error.hidden = false;
  }

  function openModal(button, form) {
    activeButton = button;
    activeForm = form;

    error.hidden = true;
    if (phoneWarning) phoneWarning.hidden = true;

    modal.hidden = false;
    document.body.classList.add('sheet-customer-open');
    nameInput.focus();
  }

  function closeModal() {
    modal.hidden = true;
    document.body.classList.remove('sheet-customer-open');
    activeForm = null;
    activeButton = null;
  }

  // Phone number: digits only, maximum 10 digits.
  phoneInput.addEventListener('input', function () {
    const originalValue = phoneInput.value;
    phoneInput.value = originalValue.replace(/\D/g, '').slice(0, 10);

    if (phoneWarning) {
      phoneWarning.hidden = true;
    }
  });

  // Intercept Add to Cart buttons before theme handlers run.
  document.addEventListener('click', async function (event) {
    const quickViewButton = event.target.closest(
      '.js-product-card-quick-view-button'
    );

    const button = event.target.closest(
      'button[name="add"], button.add-to-cart, ' +
      '.product-sticky-add-to-cart__button, ' +
      '.product-card button[type="submit"][name="add"]'
    );

    if (!quickViewButton && !button) return;

    if (submitting) return;

    // Wait until the current cart has been checked.
    if (!cartCheckComplete) {
      event.preventDefault();
      event.stopImmediatePropagation();
      await cartReady;

      if (customerDetailsCompleted) {
        // Let the customer try again normally after the cart check.
        if (button && !button.disabled) {
          button.click();
        } else if (quickViewButton && !quickViewButton.disabled) {
          quickViewButton.click();
        }
      } else {
        handleAddToCart(event, quickViewButton, button);
      }

      return;
    }

    // Once details have been submitted, let Shopify handle
    // all later Add to Cart actions normally.
    if (customerDetailsCompleted) return;

    handleAddToCart(event, quickViewButton, button);
  }, true);

  function handleAddToCart(event, quickViewButton, button) {
    if (quickViewButton) {
      if (quickViewButton.disabled || submitting) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const productCard = quickViewButton.closest('.js-product-card');
      const productHandle = quickViewButton.dataset.productCardHandle;
      const variantId = quickViewButton.dataset.variant || '';

      if (!productCard || !productHandle) {
        console.error('Product card or product handle not found.');
        return;
      }

      activeButton = quickViewButton;
      activeForm = null;

      modal.dataset.productHandle = productHandle;
      modal.dataset.variantId = variantId;

      openModal(quickViewButton, null);
      return;
    }

    if (!button || button.disabled) return;

    const form = button.form ||
      button.closest('form[action*="/cart/add"]');

    if (!form) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    activeButton = button;
    activeForm = form;

    modal.dataset.productHandle = '';
    modal.dataset.variantId =
      form.querySelector('[name="id"]')?.value || '';

    openModal(button, form);
  }

  // Close modal.
  modal.addEventListener('click', function (event) {
    if (
      event.target.closest('[data-customer-close]') &&
      !submitting
    ) {
      closeModal();
    }
  });

  // Submit customer details, save them to Google Sheets,
  // then add the product to the Shopify cart.
  continueButton.addEventListener('click', async function () {
    if (submitting || !activeButton) return;

    const name = nameInput.value.trim();
    const phone = phoneInput.value.trim();
    const state = stateInput.value.trim();

    if (!name || !phone || !state) {
      showError('Please fill in Name, Phone Number, and State.');
      return;
    }

    if (!/^[0-9]{10}$/.test(phone)) {
      showError('Please enter a valid 10-digit phone number.');
      return;
    }

    error.hidden = true;

    const formToSubmit = activeForm;
    const productHandle = modal.dataset.productHandle || '';
    const variantId =
      modal.dataset.variantId ||
      formToSubmit?.querySelector('[name="id"]')?.value ||
      '';

    if (!variantId) {
      showError(
        'Could not identify the selected product variant. Please refresh and try again.'
      );
      return;
    }

    if (
      !SCRIPT_URL.startsWith('https://script.google.com/macros/s/') ||
      !SCRIPT_URL.endsWith('/exec')
    ) {
      showError('The Google Sheets endpoint URL is not configured.');
      return;
    }

    submitting = true;
    continueButton.disabled = true;
    continueButton.textContent = 'Submitting...';

    try {
      let productName =
        document.querySelector('h1')?.textContent.trim() ||
        document.title;

      let productId = '';

      if (productHandle) {
        const productResponse = await fetch(
          `/products/${encodeURIComponent(productHandle)}.js`
        );

        if (!productResponse.ok) {
          throw new Error('Could not load product details.');
        }

        const product = await productResponse.json();
        productName = product.title;
        productId = String(product.id);
      } else {
        const pathMatch = window.location.pathname.match(
          /^\/products\/([^/]+)/
        );

        if (pathMatch) {
          const productResponse = await fetch(
            `/products/${pathMatch[1]}.js`
          );

          if (productResponse.ok) {
            const product = await productResponse.json();
            productName = product.title;
            productId = String(product.id);
          }
        }

        if (!productId) productId = variantId;
      }

      // Save customer details to Google Sheets.
      const data = new URLSearchParams({
        name,
        phone,
        state,
        product_name: productName,
        product_id: productId
      });

      // Note: no-cors cannot confirm that Google Sheets saved the row.
      await fetch(SCRIPT_URL, {
        method: 'POST',
        mode: 'no-cors',
        body: data
      });

      if (formToSubmit) {
        // Product page / sticky Add to Cart.
        // Mark details completed before Shopify submits the form.
        customerDetailsCompleted = true;
        closeModal();

        if (formToSubmit.requestSubmit) {
          formToSubmit.requestSubmit();
        } else {
          HTMLFormElement.prototype.submit.call(formToSubmit);
        }
      } else {
        // Product card / quick-view Add to Cart.
        const cartResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: Number(variantId),
              quantity: 1
            }]
          })
        });

        if (!cartResponse.ok) {
          let message = 'Could not add this product to your cart.';

          try {
            const cartError = await cartResponse.json();
            if (cartError.description) {
              message = cartError.description;
            }
          } catch (_) {}

          throw new Error(message);
        }

        // First product added: don't show modal again.
        customerDetailsCompleted = true;
        closeModal();

        // Refresh the cart drawer.
        try {
          const sectionResponse = await fetch(
            `/?sections=cart-drawer&_=${Date.now()}`,
            {
              headers: { Accept: 'application/json' },
              cache: 'no-store'
            }
          );

          if (!sectionResponse.ok) {
            throw new Error('Could not refresh the cart drawer.');
          }

          const sections = await sectionResponse.json();
          const drawerHTML = sections['cart-drawer'];

          if (!drawerHTML) {
            throw new Error(
              'Cart drawer section not found. Check the actual section ID.'
            );
          }

          const parser = new DOMParser();
          const parsedDocument = parser.parseFromString(
            drawerHTML,
            'text/html'
          );

          const updatedDrawer = parsedDocument.querySelector('#CartDrawer');
          const currentDrawer = document.querySelector('#CartDrawer');

          if (!updatedDrawer || !currentDrawer) {
            throw new Error('Could not find the updated cart drawer.');
          }

          currentDrawer.innerHTML = updatedDrawer.innerHTML;

          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              detail: { sections }
            })
          );

          const toggle = document.querySelector(
            '[data-js-toggle="CartDrawer"]'
          );

          if (toggle) {
            toggle.click();
          } else {
            currentDrawer.classList.add('is-active');
            currentDrawer.setAttribute('aria-hidden', 'false');
          }
        } catch (err) {
          console.error('Cart drawer refresh error:', err);

          showError(
            'Product added, but the cart drawer could not refresh. Please open the cart manually.'
          );
        }
      }
    } catch (err) {
      console.error('Customer details / cart error:', err);
      showError(err.message || 'Something went wrong. Please try again.');
    } finally {
      submitting = false;
      continueButton.disabled = false;
      continueButton.textContent = 'Continue to Cart';
    }
  });
})();